import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type SeriesHighlightContextValue = {
  hoveredSeriesId: string | null;
  setHoveredSeriesId: (seriesId: string | null) => void;
};

const SeriesHighlightContext = createContext<SeriesHighlightContextValue>({
  hoveredSeriesId: null,
  setHoveredSeriesId: () => undefined,
});

export const SeriesHighlightProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [hoveredSeriesId, setHoveredSeriesId] = useState<string | null>(null);

  const value = useMemo(
    () => ({ hoveredSeriesId, setHoveredSeriesId }),
    [hoveredSeriesId]
  );

  return (
    <SeriesHighlightContext.Provider value={value}>
      {children}
    </SeriesHighlightContext.Provider>
  );
};

export const useSeriesHighlight = () => useContext(SeriesHighlightContext);
